<template>
    <div style="padding: 20px; background: #fff;">
        <div class="flex just-between">
            <div>
                <el-button type="primary" plain icon="el-icon-plus" size="small" @click="handleAdd">增加</el-button>
            </div>
            <el-form :inline="true" :model="searchForm" class="demo-form-inline">
                <el-form-item label="模块名称">
                    <el-select v-model="searchForm.modularId" placeholder="模块名称" size="small" clearable>
                        <el-option v-for="item in moduleList"
                        :key="item.id"
                        :label="item.deptName"
                        :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="链接名称">
                    <el-input
                        type="text"
                        v-model="searchForm.urlName"
                        placeholder="链接名称"
                        size="small"
                        clearable
                    ></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" size="small" @click="handleSearch">查询</el-button>
                </el-form-item>
            </el-form>
        </div>

        <el-table
            :data='serviceList'
            :header-cell-style="{background: '#409EFF',color: '#fff'}"
            style="width:100%;border:none;"
            >
            <el-table-column type='index' label='序号' width="60"></el-table-column>
            <el-table-column prop="modularName" label="模块" width="200"></el-table-column>
            <el-table-column prop="urlName" label="链接名称" width="150"></el-table-column>
            <el-table-column prop="url" label="链接地址"></el-table-column>
            <el-table-column prop="sort" label="排序" width="150"></el-table-column>
            <el-table-column prop="createUser" label="创建人" width="150"></el-table-column>
            <el-table-column prop="time" label="创建时间" width="300"></el-table-column>
            <el-table-column label="操作" width="200">
                <template slot-scope="scope">
                    <el-button size="small" icon="el-icon-edit" style="margin-right:10px;" @click="handleEdit(scope.row)">修改</el-button>
                    <el-button size="small" icon="el-icon-delete" @click="handleDelete(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            style="margin:20px 0;"
            layout='->, prev,pager,next,total,sizes,jumper'
            @size-change='changeSize'
            @current-change='changeCurrent'
            :page-sizes="['10','20','30','40','50']"
            :page-size="searchForm.pageSize"
            :current-page='searchForm.pageNum'
            :total='total'
        >
        </el-pagination>

        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" :close-on-click-modal="false" width="600px">
            <el-alert
                title="同一模块下最多保存8个链接地址,超过8个将不会显示在首页"
                type="warning"
                show-icon
                style="margin-bottom: 20px;"
                :closable="false"
            ></el-alert>
            <el-form :model="service" :rules="rules" ref="editForm">
                <el-form-item label="模块名称" prop="modularId" :label-width="formLabelWidht">
                    <el-select style="width: 360px" v-model="service.modularId" clearable allow-create placeholder="请选择模块名称">
                        <el-option
                        v-for="item in moduleList"
                        :key="item.id"
                        :label="item.deptName"
                        :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="链接名称" prop="urlName" :label-width="formLabelWidht" >
                    <el-input
                        type="text"
                        v-model="service.urlName"
                        auto-complete="off"
                        placeholder="请输入链接名称"
                        style="width: 360px"
                    ></el-input>
                </el-form-item>
                <el-form-item label="链接地址" prop="url" :label-width="formLabelWidht" >
                    <el-input
                        type="text"
                        v-model="service.url"
                        auto-complete="off"
                        placeholder="请输入链接地址"
                        style="width: 360px"
                    ></el-input>
                </el-form-item>
                <el-form-item label="排序" prop="sort" :label-width="formLabelWidht" >
                    <el-input
                        type="text"
                        v-model="service.sort"
                        auto-complete="off"
                        placeholder="请输入数字作为排序"
                        style="width: 360px"
                    ></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="handleSave">保 存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                searchForm: {
                    modularId: null,
                    pageNum: 1,
                    pageSize: 10
                },
                total: 0,
                moduleList: [],
                serviceList: [],
                dialogTitle: '',
                dialogVisible: false,
                formLabelWidht: "120px",
                service: {
                    id: null,
                    modularId: null
                },
                rules: {
                    modularId: [
                    { required: true, message: "请选择模块名称", trigger: "change" },
                    ],
                    urlName: [
                    { required: true, message: "请输入链接名称", trigger: "change" },
                    { max: 9, message: "链接名称最多9个字符", trigger: "change" },
                    ],
                    url: [
                    { required: true, message: "请输入链接地址", trigger: "change" },
                    { max: 128, message: "链接地址最多32个字符", trigger: "change" },
                    ],
                    sort: [
                    { required: true, message: "请输入排序", trigger: "change" },
                    { pattern: /^[0-9]\d*$/, message: '排序码需为正整数', trigger: 'blur' }
                    ],
                }
            }
        },
        methods: {
            loadServiceList () {
                this.dialogVisible = false
                this.$api.website.getServicePageList(this.searchForm).then(res => {
                    if (res.code === 200) {
                        res.data.content.forEach(item => {
                            if (item.createTime) {
                                item.time = item.createTime.replace("T", " ").substr(0, item.createTime.indexOf("."))
                            }
                        })
                        this.serviceList = res.data.content
                        this.total = res.data.totalElements
                    } else {
                        this.$message.error(res.message)
                    }
                });
            },
            loadDeptDutyList () {
                this.$api.website.getDeptDutyPageList({
                    pageNum: 1,
                    pageSize: 100000
                }).then(res => {
                    if (res.code === 200) {
                        this.moduleList = [];
                        res.data.content.forEach(module => {
                            if (!module.root) {
                                this.moduleList.push(module);
                            }
                        });
                    } else {
                        this.$message.error(res.message)
                    }
                });
            },
            handleSearch () {
                this.loadServiceList()
            },
            handleAdd () {
                this.service = {};
                this.dislogTitle = '增加服务'
                this.dialogVisible = true
                this.$refs.editForm?.resetFields();
            },
            handleEdit (data) {
                this.service = data
                this.dislogTitle = '修改服务'
                this.dialogVisible = true
                this.$refs.editForm?.resetFields();
            },
            handleDelete (data) {
                this.$confirm('此操作将彻底删除该数据, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$api.website.removeService(data.id).then(res => {
                        if (res.code === 200) {
                            this.loadServiceList()
                        } else {
                            this.$message.error(res.message)
                        }
                    })
                })
            },
            handleSave () {
                this.$refs.editForm.validate((valid) => {
                    if (valid) {
                        if (this.service.id) {
                            this.$api.website.modifyService(this.service).then(res => {
                                if (res.code === 200) {
                                    this.loadServiceList()
                                } else {
                                    this.$message.error(res.message)
                                }
                            })
                        } else {
                            this.$api.website.addService(this.service).then(res => {
                                if (res.code === 200) {
                                    this.loadServiceList()
                                } else {
                                    this.$message.error(res.message)
                                }
                            })
                        }
                    }
                });
            },
            changeSize (value) {
                this.searchForm.pageSize = value
                this.loadServiceList()
            },
            changeCurrent (value) {
                this.searchForm.pageNum = value
                this.loadServiceList()
            },
        },
        mounted() {
            this.loadDeptDutyList()
            this.loadServiceList()
        }
    }
</script>

<style lang="scss" scoped>

</style>
